module.exports = __webpack_public_path__ + "static/media/23.ebbb30f6.png";